import React, { useEffect, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { PACKET_STATUS_OPTIONS } from '@mth/constants'
import { DropDown } from '@mth/core/components/shared/DropDown/DropDown'
import { MthColor, PacketStatus } from '@mth/enums'
import { EnrollmentPacketFormType } from './types'

type PacketStatusOptionsType = typeof PACKET_STATUS_OPTIONS

export const EnrollmentPacketDropDownButton: React.FC = () => {
  const { watch, setValue } = useFormContext<EnrollmentPacketFormType>()
  const [status] = watch(['status', 'packetStatuses'])

  const handlePacketStatus = (name: string) => {
    setValue('status', name)
    setValue('preSaveStatus', name)
  }

  const modifiedDropDownItems = useMemo<PacketStatusOptionsType>(() => {
    return PACKET_STATUS_OPTIONS.map((item) => {
      if (item.value === PacketStatus.MISSING_INFO) {
        return {
          ...item,
          disabled: true,
          color: String(MthColor.SYSTEM_11), // Grey color
          tooltip:
            'To update the status, please use the Missing Info button. If this packet is currently marked as Accepted, please select either Submitted or Resubmitted to activate the button.',
        }
      }
      return item
    })
  }, [])

  useEffect(() => {
    if (PACKET_STATUS_OPTIONS) {
      setValue(
        'packetStatuses',
        PACKET_STATUS_OPTIONS.map((item) => `${item.value}`),
      )
    }
  }, [PACKET_STATUS_OPTIONS])

  return (
    <DropDown
      sx={{
        fontSize: '12px',
        padding: '2px 30px 1px 40px',
        background: MthColor.BUTTON_LINEAR_GRADIENT,
        height: '35px',
        borderRadius: '8px',
        '& .MuiSelect-select': {
          color: 'white',
          fontWeight: 500,
          fontSize: '12px',
        },
        '& .MuiSvgIcon-root': {
          color: 'white !important',
        },
      }}
      dropDownItems={modifiedDropDownItems}
      defaultValue={status}
      borderNone={true}
      setParentValue={(val) => {
        handlePacketStatus(`${val}`)
      }}
    />
  )
}
